import { render } from "./bet-report-detail-confirm.vue?vue&type=template&id=6f807e6c&scoped=true"
import script from "./bet-report-detail-confirm.vue?vue&type=script&lang=js"
export * from "./bet-report-detail-confirm.vue?vue&type=script&lang=js"

import "./bet-report-detail-confirm.vue?vue&type=style&index=0&id=6f807e6c&scoped=true&lang=less"

import exportComponent from "F:\\workspan\\java\\lhc\\hk-lottery-lhc-ui\\hk-lottery-lhc-pc-ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f807e6c"]])

export default __exports__